module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admincolaboradores-crear/admincolaboradores-crear.component.scss
// module id = ./src/app/admincolaboradores-crear/admincolaboradores-crear.component.scss
// module chunks = main